<ion-button fill="clear" color="light" [ngClass]="'theme-' + theme" (click)="onLanguageSelect()" class="lang-button">
  <ion-label [attr.aria-label]="'menuGeneral.languageSelect' | translate">{{ languageLabel }}</ion-label>
</ion-button>
